import { useRef, useState } from "react";
import * as publicApi from "../../../../service/publicApi";
import Button from "../../../material/button/Button";
import InputV2 from "../../../material/input/InputV2";

const role_list = [
  { key: "LABORATORY_PERSONNEL", value: "ผู้ปฏิบัติการในห้องปฏิบัติการ" },
  { key: "LABORATORY_ADMIN", value: "ผู้ดูแลห้องปฏิบัติการ" },
];

const Petition = ({ petition, onInputChange, role, type = "petition" }) => {
  const inputFileRef = useRef(null);
  const [loading, setLoading] = useState(false);

  const inputFileChange = async (event) => {
    const fileObj = event.target.files?.[0];
    if (!fileObj) return;

    const formData = new FormData();
    formData.append("file", fileObj);
    formData.append("file_name", fileObj.name);

    setLoading(true);
    const res = await publicApi.attachment(formData);
    setLoading(false);

    if (res?.data?.code === 200) {
      onInputChange("attachFile", res.data.file, role, type);
    } else {
      // console.log("เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่");
    }
  };

  const roleName = role_list.find((r) => r.key === role)?.value || role;
  return (
    <div className="flex flex-col flex-wrap justify-center items-start w-full gap-2 rounded-md border border-[#E2E2E4] p-4 mb-4">
      <div className="flex flex-row items-center justify-center w-full">
        <div className="flex flex-col text-[16px] font-['Prompt'] w-full">
          ตำแหน่ง
          <InputV2
            type="text"
            placeholder="ตำแหน่ง"
            value={petition.position || ""}
            onChangeEvt={(value) =>
              onInputChange("position", value, role, "petition")
            }
          />
        </div>
      </div>
      <div className="flex flex-row items-center justify-center">
        <div>เลือกหน้าที่</div>
        <div className="mr-[20px]">(เลือกได้มากกว่า 1 ข้อ)</div>
        <div className="flex items-center gap-2 mr-[20px]">
          <input
            id={`analyst-${role}`}
            checked={petition.analyst || false}
            onChange={(e) => {
              onInputChange("analyst", e.target.checked, role, type);
            }}
            type="checkbox"
            className="w-4 h-4 cursor-pointer"
          />
          <label htmlFor={`analyst-${role}`} className="cursor-pointer">
            ผู้วิเคราะห์
          </label>
        </div>

        <div className="flex items-center gap-2">
          <input
            id={`approver-${role}`}
            checked={petition.approver || false}
            onChange={(e) => {
              onInputChange("approver", e.target.checked, role, type);
            }}
            type="checkbox"
            className="w-4 h-4 cursor-pointer"
          />
          <label htmlFor={`approver-${role}`} className="cursor-pointer">
            ผู้รับรองผล
          </label>
        </div>
      </div>
      <h2 className="text-lg font-semibold">คำร้องขอใช้ระบบ ({roleName})</h2>
      <p className="break-words whitespace-normal text-[18px] 2sm:text-[16px]">
        สำหรับนักวิทยาศาสตร์การแพทย์
        หรือเจ้าหน้าที่ในวิชาชีพที่ไม่มีเลขใบประกอบวิชาชีพ
        เพื่อให้ผู้ดูแลระบบในระดับห้องปฏิบัติการรับรองและอนุญาตการทำงานของเจ้าหน้าที่
      </p>
      {loading ? null : (
        <div className="flex flex-row md:flex-col justify-center items-center gap-[10px] w-full">
          <Button onClick={() => inputFileRef.current.click()}>แนบไฟล์</Button>
          <input
            type="file"
            ref={inputFileRef}
            onChange={inputFileChange}
            style={{ display: "none" }}
          />
          {petition.attachFile && (
            <div className="text-sm text-green-600">
              ไฟล์ที่แนบ: {petition.attachFile.file_name}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default Petition;
